import { useDeepEffect } from '@domain-group/react-hooks'
import { Dispatch, SetStateAction, useState } from 'react'

type ModifySortParams = {
  fromIndex: number,
  toIndex: number,
  setSortedIds: Dispatch<SetStateAction<number[]>>,
  updateSort?: (idArray: number[]) => void,
}

const modifySort = (params: ModifySortParams) => {
  const {
    fromIndex, toIndex, setSortedIds, updateSort,
  } = params

  setSortedIds((currentIds) => {
    const sortedIds = [...currentIds]
    const [removedItemId] = sortedIds.splice(fromIndex, 1)
    sortedIds.splice(toIndex, 0, removedItemId)

    if (updateSort) updateSort(sortedIds)

    return sortedIds
  })
}

type IdSortParams = {
  callbacks?: {
    updateSort: (idArray: number[]) => void,
  },
  idsArray: number[],
}

function useIdSort(params: IdSortParams) {
  const { callbacks, idsArray = [] } = params
  const { updateSort } = callbacks || {}

  const [sortedIds, setSortedIds] = useState<number[]>([])

  useDeepEffect(() => {
    if (idsArray) setSortedIds(idsArray)
  }, [idsArray])

  return {
    callbacks: {
      modifySort: (fromIndex: number, toIndex: number) => modifySort({
        fromIndex, toIndex, setSortedIds, updateSort,
      }),
    },
    sortedIds,
  }
}

export default useIdSort
